<template>
    <div class="main-bg">
        <div class="flex flex-col flex-auto w-full h-full" style="max-height: 100vh;height: 100vh !important;overflow-y: scroll;">
            <div class="flex flex-col flex-auto">
                <!-- <div class="login-outlet flex flex-col cr-backimg-new" style="background: url('/static/images/new-theme2024/login_bg1.png') !important;"> -->
                <div class="login-outlet flex flex-col cr-backimg">
                    <div class="flex items-center justify-between w-full padding-x padding-bottom ">
                        <div class="flex md:justify-start py-5">
                            <div style="" class="pl-2 text-white fs-24 fw-600">
                                <a href="https://www.digicollect.com/" target="_blank" class="">
                                    <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/digi_logo_white_1.png" alt="DigiCollect" class="digiadmin-logo mb-3" style="width: 170px; height: auto;"> 
                                    <!-- <img v-else src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/Digicollect_Logo.svg" alt="DigiCollect" class="digiadmin-logo mb-3" style="width: 34px; height: auto;padding: 1px;border-radius: 4px;">  -->
                                </a>
                            </div>
                        </div>
                        <!-- Digihelp -->
                        <div v-if="product_name=='DigiHelp'" class="flex items-end justify-end text-default-blue crm-right-logo py-6 pr-2" style="font-size: 23px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/help_whitelogo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 35px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                            DigiHelp
                        </div>
                        <!-- HRMS -->
                        <div v-else-if="product_name=='DigiHRMS'" class="flex items-end justify-end text-default-blue crm-right-logo py-6 pr-2" style="font-size: 23px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/hrms_newlogo.svg" alt="DigiHRMS" class="digiadmin-logo" style="width: 35px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                            <span class="mt-2">DigiHRMS</span>
                        </div>
                        <!-- Admin -->
                        <div v-else-if="product_name=='DigiAdmin'" class="flex items-end justify-end text-default-blue crm-right-logo py-6 pr-2" style="font-size: 23px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/admin-logo.svg" alt="DigiAdmin" class="digiadmin-logo" style="width: 35px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                            <span class="mt-1">DigiAdmin</span>
                        </div>
                        <!-- DigiExpense -->
                        <div v-else-if="product_name=='DigiExpense'" class="flex items-end justify-end text-default-blue crm-right-logo py-6 pr-2" style="font-size: 23px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/expense-logo.svg" alt="DigiExpense" class="digiadmin-logo" style="width: 35px; height: auto;border: 1px solid #fff;padding: 6px 9px;border-radius: 14px;"> 
                            </div>
                            <span class="mt-1">DigiExpense</span>
                        </div>
                        <div v-else-if="product_name=='DigiCloud'" class="flex items-end justify-end text-default-blue crm-right-logo py-6 pr-2" style="font-size: 23px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;">
                            <div style="" class="px-1 mr-1">
                                <img src="/static/images/diginewLogo.svg" alt="DigiExpense" class="digiadmin-logo" style="width: 35px; height: 30px;border: 0.5px solid #fff;padding: 6px 9px;border-radius: 4px;"> 
                            </div>
                            <span class="mt-1">DigiCloud</span>
                        </div>
                    </div>
                    <!-- flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0 pb-5 -->
                    <div class="height-container pb-10 mt-0 margin-t">
                        <div class="d-flex flex-col align-items-center justify-center w-full sm:w-auto sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card mb-15">
                            <div>
                                <div class="right-box">
                                    <div v-if="activediv == 'login'">
                                        <div class="app-brand justify-content-center">
                                            <div class="app-brand-link">
                                                <span class="app-brand-logo demo">
                                                    <img v-if="product_name=='DigiExpense'" src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/digiexpense_white.png" alt="Expense Logo" class="appbrand-logo"/> 
                                                    <img v-else-if="product_name=='DigiCloud'"  src="https://cdn.digicollect.com/cdn/cloud/images/cloud_white.png" alt="Cloud Logo" class="appbrand-logo"/> 
                                                    <img v-else-if="product_name=='DigiAdmin'"  src="https://cdn.digicollect.com/cdn/dc_admin/img/admin-logo.svg" alt="Admin Logo" class="appbrand-logo"/> 
                                                    <img v-else-if="product_name=='DigiHRMS'"  src="https://cdn.digicollect.com/cdn/dc_admin/img/hrms_newlogo.svg" alt="Hrms Logo" class="appbrand-logo"/> 
                                                </span>
                                            </div>
                                        </div>
                                        <div v-if="product_name=='DigiExpense'" style="text-align: center !important;">
                                            <span class="productbrand-name">
                                                Expense Management Login
                                            </span>
                                        </div>
                                        <div v-else-if="product_name=='DigiCloud'" style="text-align: center !important;">
                                            <span class="productbrand-name">
                                                Cloud Login
                                            </span>
                                        </div>
                                        <div v-else-if="product_name=='DigiAdmin'" style="text-align: center !important;">
                                            <span class="productbrand-name">
                                                Admin Login
                                            </span>
                                        </div>
                                        <div v-else-if="product_name=='DigiHRMS'" style="text-align: center !important;">
                                            <span class="productbrand-name">
                                                HRMS Login
                                            </span>
                                        </div>
                                        <!-- <div class="tagline-login">
                                            Keep track and retrieve all your expenses with convenience and ease in real time. 
                                        </div> -->
                                        <!-- <div v-if="enter_email_screen">
                                        </div> -->
                                        <form action="javascript:;">
                                            <div v-if="enter_email_screen" class="mt-0 px-3">
                                                <div class="h-30-20-10rem pt-2">
                                                    <p class="text-default-heading mb-2 text-white fw-600">Email<sup class="star pl-0-2">*</sup></p>
                                                    <div class="w-100" v-if="oldlogin_id">
                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <div class="input-group-login">
                                                                <span class="input-group-text-login" id="basic-addon1">
                                                                    <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                    <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/email-login.png" class="img-email-login" />
                                                                </span>
                                                                <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" maxlength="238" class="form-control-login" autofocus name="userid" placeholder="Enter Email Address" v-validate="'required'" v-model="form.login_id">
                                                            </div>
                                                            <!-- <input type="text" autocomplete="off" maxlength="238" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" v-validate="'required'" v-model="form.login_id"> -->
                                                        </div>
                                                    </div>
                                                    <div class="w-100" v-if="login_id_true">
                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <div class="input-group-login">
                                                                <span class="input-group-text-login" id="basic-addon1">
                                                                    <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                    <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/email-login.png" class="img-email-login" />
                                                                </span>
                                                                <input type="text" autocomplete="off" class="form-control-login-pass" autofocus name="userid" @keyup.enter="goToNext('login')" placeholder="Enter Email Address" @input="checkUserIdback" v-model="form.login_id" >
                                                                <span class="input-group-pass-right">
                                                                    <img src="/static/images/check-fill.svg" width="20px">
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- v-if="is_email_valid_text && form.login_id != ''" -->
                                                    <span class="text-danger-login fw-600 fs-14 mb-5" style="text-transform: none !important;" v-show="errors.has('userid')" v-if="is_email_valid_text && form.login_id != ''" >Please Enter a Valid Email Address</span>
                                                    <span v-if="is_email_phone_valid" class="text-danger-login fw-600 fs-14 mb-5" style="text-transform: none !important;">{{is_email_phone_valid_text}}</span>
                                                </div>
                                                <!-- <div v-if="login_id_true" class="forgot-password-button mt-8" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize fs-14 mr-5" type="button" @click="checkUserIdEmpty">Cancel</button>
                                                    <button class="btn newsign-in text-capitalize fs-14" :disabled="form.login_id == '' || ajax_progress"  type="button" @click="goToNext('login')">Login
                                                        <half-circle-spinner v-if="ajax_progress" style="position: absolute;bottom: 6px;left:95px;display: flex;justify-content: center;" :animation-duration="1000" :size="20" color="#2D837E" />
                                                    </button>
                                                </div>
                                                <div v-else class="mt-3 d-flex justify-content-center align-items-center">
                                                    <button class="btn newsign-in text-capitalize font-weight-bold fs-14" :disabled="form.login_id == '' || ajax_progress" type="button" @click="goToNext('login')">Login
                                                            <half-circle-spinner v-if="ajax_progress" style="position: absolute;bottom: 6px;left:95px;display: flex;justify-content: center" :animation-duration="1000" :size="20" color="#2D837E" />
                                                    </button>
                                                </div> -->
                                                <div class="text-center">
                                                    <div class="mt-3">
                                                        <button class="btn newsign-in-btn text-capitalize font-weight-bold fs-14" :disabled="form.login_id == '' || ajax_progress" type="button" @click="goToNext('login')">Login Via Password
                                                                <half-circle-spinner v-if="ajax_progress" style="position: absolute;bottom: 6px;left:150px;display: flex;justify-content: center" :animation-duration="1000" :size="20" color="#2D837E" />
                                                        </button>
                                                    </div>
                                                    <div class="mt-2 fw-600 text-white fs-16 d-flex justify-content-center">
                                                        <div class="mt-1">
                                                            <hr>
                                                        </div>
                                                        <div class="px-2 fs-18 fw-800">or</div>
                                                        <div class="mt-1">
                                                            <hr>
                                                        </div>
                                                    </div>
                                                    <div class="mt-3">
                                                        <button class="btn newsign-in-btn text-capitalize font-weight-bold fs-14" :disabled="form.login_id == '' || ajax_progress_otp" type="button" @click="loginCheckOtp">Login Via OTP
                                                                <half-circle-spinner v-if="ajax_progress_otp" style="position: absolute;bottom: 6px;left:150px;display: flex;justify-content: center" :animation-duration="1000" :size="20" color="#2D837E" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="user_not_verified" class="mt-2">
                                                <h1 v-if="login_type == 'email'" class="fs-14 mb-2 fw-600 text-white" style="margin-left:-6px !important"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                                <h1 v-if="login_type == 'phone'" class="fs-14 mb-2 fw-600 text-white" style="margin-left:-6px !important"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                                <div class="text-center" style="max-width: 380px">
                                                    <div class="mb-2 ml-auto mr-auto" style="max-width: 230px">
                                                        <img style="width: 80%;" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/duck.svg" alt="Duck" />
                                                    </div>
                                                    <p class="text-white mb-2" style="font-size: 20px; font-weight: 800;">Verification Pending!!</p>
                                                    <p class="text-white mb-2" style="font-size: 14px;">Your Verification link has been expired, Resend Link to verify</p>
                                                    <div class="mt-4">
                                                        <div class="forgot-password-button" style="text-align: center;">
                                                            <button class="btn newcancel text-capitalize mb-2 mr-5" :disabled="resend_btn_disable" @click="cancelResendLink">Cancel</button>
                                                            <button class="btn newsign-in mb-2 text-capitalize" :disabled="resend_btn_disable" style="min-width: 110px; width: 160px !important;" @click="resendUserVerifyLink">Resend Link 
                                                                <!-- <hollow-dots-spinner v-if="resend_btn_disable" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /> -->
                                                                <half-circle-spinner  v-if="resend_btn_disable" :animation-duration="1000" style="bottom: 22px;left:90px;" :size="20" color="#2D837E" />

                                                            </button>
                                                        </div>
                                                        <div v-if="resend_verification_link_success" class="text-default-blue fs-14 mt-2">{{resend_verification_link_success}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="enter_pass_screen" class="mt-2 px-3">
                                                <!-- <h1 v-if="login_type == 'email'" class="fs-14 mb-2 fw-600 text-white pl-2" style="margin-left:-6px !important"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1> -->
                                                <div class="h-30-20-10rem pt-2" v-if="login_type == 'email'">
                                                    <p class="text-default-heading mb-2 text-white fw-600">Email<sup class="star pl-0-2">*</sup></p>
                                                    <div class="w-100">
                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <div class="input-group-login">
                                                                <span class="input-group-text-login" id="basic-addon1">
                                                                    <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                    <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/email-login.png" class="img-email-login" />
                                                                </span>
                                                                <input type="text" autocomplete="off" maxlength="238" class="form-control-login pointer-none" autofocus name="userid" placeholder="Enter Email Address" v-validate="'required'" v-model="form.login_id">
                                                            </div>
                                                            <!-- <input type="text" autocomplete="off" maxlength="238" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" v-validate="'required'" v-model="form.login_id"> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <h1 v-if="login_type == 'phone'" class="fs-14 mb-2 fw-600 text-white" style="margin-left:-6px !important"><img src="/static/images/author-img.svg" alt="" width="34px"> <span class="text-white">{{form.login_id}}</span></h1>
                                                <div v-if="!sign_in_using_otp" class="">
                                                    <p class="text-default-heading mb-2 text-white fw-600">Password<sup class="star pl-0-2">*</sup></p>
                                                    <div class="d-flex">
                                                        <div class="input-group-login">
                                                            <span class="input-group-pass-login" id="basic-addon1">
                                                                <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/password-lock.png" class="img-email-login" />
                                                            </span>
                                                            <input v-if="!showPassword"  oncut="return false" type="password"  autocomplete="off" class="form-control-login-pass" placeholder="Enter Password" v-model="form.password" @keydown.enter="loginUsingPassword('one-step')" name="password" ref="password" >
                                                            <input v-else type="text"  oncut="return false"  autocomplete="off" class="form-control-login-pass" placeholder="Enter Password " v-model="form.password" name="password" @keydown.enter="loginUsingPassword('one-step')" ref="password">
                                                            <span v-if="!showPassword" class="input-group-pass-right" @click="showPassword =!showPassword">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                            </span>
                                                            <span v-else class="input-group-pass-right" @click="showPassword = !showPassword">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <p v-if="password_error_text" class="text-danger-login mb-5">{{password_error_text}}</p>
                                                    <p class="default-link mb-2 mt-1 text-white" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer highlighted-white">Forgot your password?</span></p>
                                                    <div class="mt-4 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelPassScreen">Cancel</button>
                                                        <button :disabled="signedIn || form.password == ''" class="btn newsign-in text-capitalize" @click="loginUsingPassword('one-step')">Login
                                                            <!-- <hollow-dots-spinner v-if="signedIn" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /> -->
                                                            <half-circle-spinner  v-if="signedIn" :animation-duration="1000" style="bottom: 22px;left:90px;" :size="20" color="#2D837E" />
                                                        </button>
                                                    </div>
                                                    <!-- <div v-if="signedIn" style="text-align: center;" class="mt-2">
                                                        <p class="fs-14 mt-0 fw-600 pointer default-link highlighted-white" style="color: #fff !important;">Login using OTP</p>
                                                    </div>
                                                    <div v-else style="text-align: center;" class="mt-2">
                                                        <p class="fs-14 mt-0 fw-600 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToOtpLogin('send')" >Login using OTP</p>
                                                    </div> -->
                                                </div>
                                                <div v-if="sign_in_using_otp" class="">
                                                    <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code<sup class="star">*</sup></span>
                                                    <div >
                                                        <div class="d-flex align-items-start mt-2">
                                                            <div class="" @keyup.enter="loginUsingOtp('one-step')">
                                                                <v-otp-input
                                                                ref="otpInput"
                                                                :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                                separator=""
                                                                :num-inputs="6"
                                                                :should-auto-focus="true"
                                                                :is-input-num="true"
                                                                @on-complete="loginUsingOtp($event, 'one-step')"
                                                                @on-change="otpChangeDetected"
                                                                />
                                                                <div class="d-flex justify-between">
                                                                    <div style="width: 190px;" class="pt-2">
                                                                        <span class="text-white highlighted-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                                    </div>
                                                                    <div style="color: #00448b" class="ml-1 mt-2 pr-4">
                                                                        <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')" :class="{'resend-active': !countdown != 0}">Resend code</button>
                                                                        <br>
                                                                        <span v-if="countdown > 0"  class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                                        <!-- <div v-if="code_resending" style="color: #fff; cursor: pointer;">Resending Code...</div> -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div v-if="resend_code_success_text" class="mt-2">
                                                            <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                        </div> -->
                                                        <div v-if="countdown > 0" class="mt-4 text-center">
                                                            <span class="text-default-blue text-underline fs-14">OTP has been sent to your registered Email</span>
                                                        </div>
                                                        <div v-if="otp_error_text" class="mt-2 ml-2">
                                                            <span class="text-danger-login fw-600 fs-14">{{otp_error_text}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="mt-4 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize" :disabled="signedIn" @click="loginUsingOtp('one-step')">Login
                                                            <!-- <hollow-dots-spinner v-if="signedIn" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /> -->
                                                            <half-circle-spinner  v-if="signedIn" :animation-duration="1000" style="bottom: 22px;left:90px;" :size="20" color="#2D837E" />
                                                        </button>
                                                    </div>
                                                    <!-- <div class="mt-2 forgot-password-button" style="text-align: center;">
                                                        <div v-if="signedIn" style="text-align: center;">
                                                            <p class="fs-14 fw-600  mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToPassLogin">Login Using Password</p>
                                                        </div>
                                                        <div v-else style="text-align: center;">
                                                            <p class="fs-14 mt-2 fw-600 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToPassLogin">Login Using Password</p>
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div v-if="two_factor_authentication" class="mt-2">
                                                <h1 v-if="login_type == 'email'" class="fs-14 mb-2 fw-600 text-white pl-2" style="margin-left:-6px !important"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                                <h1 v-if="login_type == 'phone'" class="fs-14 mb-2 fw-600 text-white pl-2" style="margin-left:-6px !important"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                                <div v-if="two_factor_auth_pass_screen_active" class="px-3">
                                                    <p class="text-default-heading mb-2 text-white fw-600">Password<sup class="star pl-0-2">*</sup></p>
                                                    <div class="d-flex">
                                                        <div class="input-group-login">
                                                            <span class="input-group-pass-login" id="basic-addon1">
                                                                <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/password-lock.png" class="img-email-login" />
                                                            </span>
                                                            <!-- <input v-if="!showPassword" autofocus @keyup.enter="otpInputActive"  style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password sdf sd" v-model="form.password" name="password"> -->
                                                            <input v-if="!showPassword" id="name" ref="password" @keydown.enter="otpInputActive"   oncut="return false" type="password"  autocomplete="off" class="form-control-login-pass" placeholder="Enter Password " v-model="form.password" name="password" autofocus>
                                                            <input v-else type="text" autofocus ref="password" name="password" @keydown.enter="otpInputActive"   oncut="return false"  autocomplete="off" class="form-control-login-pass" placeholder="Enter Password" v-model="form.password">
                                                            <span v-if="!showPassword" class="input-group-pass-right" @click="showPassword = !showPassword">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                            </span>
                                                            <span v-else class="input-group-pass-right" @click="showPassword = !showPassword">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <p v-if="password_error_text" class="text-danger-login mb-5 ml-1">{{password_error_text}}</p>
                                                    <p v-if="signedIn" class="default-link mb-5 mt-1 text-white highlighted-white " style="color: #fff !important;text-align: end;"><span>Forgot your password?</span></p>
                                                    <p v-else class="default-link mb-5 text-white" @click="forgotPassword" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer highlighted-white">Forgot your password?</span></p>
                                                    <div class="mt-4 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelTwoFactor">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize" :disabled="signedIn || form.password == ''" @click="otpInputActive">Login
                                                            <!-- <hollow-dots-spinner v-if="signedIn" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /> -->
                                                            <half-circle-spinner  v-if="signedIn" :animation-duration="1000" style="bottom: 22px;left:90px;" :size="20" color="#2D837E" />
                                                        </button>
                                                    </div>
                                                    <!-- <p class="fs-14 mt-2 fw-600 pointer default-link highlighted-white" v-if="!signedIn" style="color: #fff !important;text-align: center;" @click="goToOtpLogin('send', 'two-factor-otp')">Login Using OTP</p>
                                                    <p class="fs-14 mt-2 fw-600 pointer default-link highlighted-white" v-if="signedIn" style="color: #fff !important;text-align: center;">Login Using OTP</p> -->
                                                </div>
                                                <div v-if="!two_factor_auth_pass_screen_active" class="ml-2">
                                                    <span class="text-default-heading text-white ml-1 pb-6 fs-12 fw-600">Enter 6-Digit OTP Code<sup class="star">*</sup></span>
                                                    <div class="d-flex align-items-start pt-2 ml-1">
                                                        <div class="" @keyup.enter="loginUsingOtp('two-step')">
                                                            <v-otp-input
                                                            ref="otpInput"
                                                            :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                            separator=""
                                                            :num-inputs="6"
                                                            :should-auto-focus="true"
                                                            :is-input-num="true"
                                                            @on-complete="loginUsingOtp($event, 'two-step')"
                                                            @on-change="otpChangeDetected"
                                                            />
                                                            <div class="d-flex justify-between">
                                                                <div style="width: 190px;" class="pt-2">
                                                                    <span class="text-white highlighted-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                                </div>
                                                                <div style="color: #00448b" class="ml-1 mt-2 pr-4">
                                                                    <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')" :class="{'resend-active': !countdown != 0}">Resend code</button>
                                                                    <br>
                                                                    <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                                </div>
                                                                <!-- <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div v-if="resend_code_success_text" class="mt-2">
                                                        <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                    </div> -->
                                                    <div v-if="countdown > 0" class="mt-4 text-center">
                                                        <span class="text-default-blue text-underline fs-14">OTP has been sent to your registered Email</span>
                                                    </div>
                                                    <div v-if="otp_error_text" class="mt-2 ml-2">
                                                        <span class="text-danger-login fw-600 fs-14">{{otp_error_text}}</span>
                                                    </div>
                                                    <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="two_step_signed_in_otp">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize" :disabled="two_step_signed_in_otp" @click="loginUsingOtp('two-step')">Login
                                                            <!-- <hollow-dots-spinner v-if="two_step_signed_in_otp" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" /> -->
                                                            <half-circle-spinner v-if="two_step_signed_in_otp" :animation-duration="1000" style="bottom: 22px;left:90px;" :size="20" color="#2D837E" />
                                                        </button>
                                                    </div>
                                                    <!-- <div style="text-align: center;" class="mt-2">
                                                        <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToPassLogin('two-factor-password')">Login Using Password</p>
                                                        <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" v-if="otp_signin_btn && password_button" style="color: #fff !important;">Login Using Password</p>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="activediv == 'forgot password'">
                                        <div class="px-3">
                                            <div style="text-align: center !important;">
                                                <span class="text-white text-center fs-30 fw-600">
                                                    Forgot Pass<span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">word</span>
                                                </span>
                                            </div>
                                            <div class="h-30-18-10rem">
                                                <p class="text-default-heading text-white mb-2 mt-6 fw-600">Email Address <sup class="star">*</sup></p>
                                                <div class="input-group-login">
                                                    <span class="input-group-text-login" id="basic-addon1">
                                                        <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                        <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/email-login.png" class="img-email-login" />
                                                    </span>
                                                    <input autocomplete="off" type="text" class="form-control-login" placeholder="Enter Email Address" v-model="form.login_id" @input="checkUserIdback" @keyup.enter="goToNext('forgot-pass')">
                                                </div>
                                                <div v-if="is_email_phone_valid && form.login_id != ''" class="text-danger-login fw-600 fs-14" style="text-transform: none !important;">{{is_email_phone_valid_text}}</div>
                                                <div v-if="is_email_phone_valid_text_forget_pass" class="text-danger-login fw-600 fs-14" style="text-transform: none !important;">{{is_email_phone_valid_text_forget_pass}}</div>
                                            </div>
                                            <div class="mt-4 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forget_pass_btn_disable">Cancel</button>
                                                <button  class="btn newsign-in text-capitalize" @click="goToNext('forgot-pass')">Verify</button>
                                            </div>
                                            <!-- <div style="text-align: center;" class="mt-2">
                                                <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="forgotPasswordCancel">Login</p>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div v-if="activediv == 'verify otp'">
                                        <div class="px-3">
                                            <div style="text-align: center !important;">
                                                <span class="text-white text-center fs-30 fw-600">
                                                    Forgot Pass<span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">word</span>
                                                </span>
                                            </div>
                                            <!-- <hr style="margin-left: 235px !important;width: 70px !important;margin-top: -6px !important;"> -->
                                            <!-- <h1 v-if="is_using_email" class="fs-14 mb-3 mt-6 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1> -->
                                            <div class="h-30-18-10rem" v-if="is_using_email">
                                                <p class="text-default-heading text-white mb-2 mt-6 fw-600">Email Address <sup class="star">*</sup></p>
                                                <div class="input-group-login">
                                                    <span class="input-group-text-login" id="basic-addon1">
                                                        <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                        <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/email-login.png" class="img-email-login" />
                                                    </span>
                                                    <input autocomplete="off" type="text" class="form-control-login pointer-none" placeholder="Enter Email Address" v-model="form.login_id">
                                                </div>
                                            </div>
                                            <!-- <h1 v-if="is_using_mobile" class="fs-14 mb-3 mt-6 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1> -->
                                            <div>
                                                <div class="text-default-heading fw-600 mr-6 fs-14 text-white pb-2">Please provide the 6-digit OTP code sent to your email address.</div>
                                                <div class="d-flex align-items-start mt-5">
                                                    <div class="" @keyup.enter="verifyOtpForgotPass">
                                                        <v-otp-input
                                                        ref="otpInput"
                                                        :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                        separator=""
                                                        :num-inputs="6"
                                                        :should-auto-focus="true"
                                                        :is-input-num="true"
                                                        @on-complete="verifyOtpForgotPass($event)"
                                                        @on-change="otpEntered"
                                                        />
                                                        <div class="d-flex justify-between">
                                                            <div style="width: 190px;" class="pt-2">
                                                                <span class="highlighted-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                            </div>
                                                            <div style="color: #00448b" class="ml-1 mt-2 pr-4">
                                                                <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="getOtpForgetPass('resend')" :class="{'resend-active': !countdown != 0}">Resend code</button>
                                                                <br>
                                                                <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                            </div>
                                                            <!-- <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div v-if="resend_code_success_text" class="mt-2">
                                                    <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                </div> -->
                                                <div v-if="countdown > 0" class="mt-4 text-center">
                                                    <span class="text-default-blue  text-underline fs-14">OTP has been sent to your registered Email</span>
                                                </div>
                                                <div v-if="otpInvalid" class="mt-2 ml-2">
                                                    <span class="text-danger-login fw-600 fs-14">{{otp_error_text}}</span>
                                                </div>
                                                <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forgot_pass_otp_success">Cancel</button>
                                                    <button :disabled="forgot_pass_otp_success" class="btn newsign-in text-capitalize" @click="verifyOtpForgotPass">Verify</button>
                                                </div>
                                                <div style="text-align: center;" class="mt-2">
                                                    <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="forgotPasswordCancel">Login</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activediv == 'set new password'" style="height:100%;">
                                        <div>
                                            <div style="text-align: center !important;">
                                                <span class="text-white text-center fs-30 fw-600">
                                                    Set New Pass<span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">word</span>
                                                </span>
                                            </div>
                                            <!-- <h1 v-if="is_using_email" style="margin-left:-6px !important" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1> -->
                                            <div class="h-30-18-10rem" v-if="is_using_email">
                                                <p class="text-default-heading text-white mb-2 mt-6 fw-600">Email Address <sup class="star">*</sup></p>
                                                <div class="input-group-login pr-4">
                                                    <span class="input-group-text-login" id="basic-addon1">
                                                        <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                        <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/email-login.png" class="img-email-login" />
                                                    </span>
                                                    <input autocomplete="off" type="text" class="form-control-login pointer-none" placeholder="Enter Email Address" v-model="form.login_id" >
                                                </div>
                                            </div>
                                            <!-- <h1 v-if="is_using_mobile" style="margin-left:-6px !important" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1> -->
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="text-default-heading text-white fw-600">Enter New Password<sup class="star">*</sup></span>
                                                    <div class="d-flex aligm-items-center mt-2 position-relative">
                                                        <div class="input-group-login">
                                                            <span class="input-group-pass-login" id="basic-addon1">
                                                                <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/password-lock.png" class="img-email-login" />
                                                            </span>
                                                            <input  autocomplete="off"  v-if="!showNewPassword"  type="password" @input="onPassInput" class="form-control-login-pass" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                            <input  autocomplete="off"  v-else type="text"  class="form-control-login-pass" @input="onPassInput" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                            <span @click="showNewPassword = !showNewPassword" class="input-group-pass-right">
                                                                <img v-if="!showNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                                <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                            </span>
                                                        </div>
                                                        <password-meter :pwd="form.password" id="password" style="display:none"></password-meter>
                                                        <span class="ml-2 mt-2" style="margin-right: -10px;">
                                                            <el-tooltip effect="light" placement="left">
                                                                <div slot="content" style="color :#000000; W1font-size: 12px;">
                                                                    <span style="font-weight: 600;">Password must contain the following</span>
                                                                    <br>
                                                                    <span >
                                                                        <span class="text-black">
                                                                            <i v-if="is_uppercase_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger-login fs-14 mr-1"></i>
                                                                            At-least one uppercase letter (ex: A to Z)
                                                                        </span><br>
                                                                        <span class="text-black">
                                                                            <i v-if="is_number_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger-login fs-14 mr-1"></i>
                                                                            At-least one digit (ex: 0 to 9)
                                                                        </span><br>
                                                                        <span class="text-black">
                                                                            <i v-if="is_special_character_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger-login fs-14 mr-1"></i>
                                                                            At-least one special character (ex: $,#,@,!,%,^,&,*,(,),)<br>
                                                                        </span>
                                                                        <span class="text-black">
                                                                            <i v-if="min_pwd_length" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger-login fs-14 mr-1"></i>
                                                                            Minimum 8 characters
                                                                        </span><br>
                                                                    </span>
                                                                </div>
                                                                <i class="icon-information text-default-blue fs-18"></i>
                                                            </el-tooltip>
                                                        </span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger-login fw-600 fs-14 mb-5 position-absolute" style="margin-top: 4px !important;" v-show="errors.has('new_password')">Please Enter New Password</span>
                                                </div>
                                            </div>
                                            <div class="row mt-7">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="text-default-heading text-white fw-600 mt-5">Confirm New Password<sup class="star">*</sup></span>
                                                    <div class="d-flex aligm-items-center mt-2 position-relative">
                                                        <div class="input-group-login pr-4">
                                                            <span class="input-group-pass-login" id="basic-addon1">
                                                                <!-- <i class="icon icon-email fs-24 text-white"></i> -->
                                                                <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/password-lock.png" class="img-email-login" />
                                                            </span>
                                                            <input v-if="!showConfirmNewPassword"   type="password" name="confirmpassword" class="form-control-login-pass" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                            <input v-else type="text" class="form-control-login-pass" name="confirmpassword" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                            <span @click="showConfirmNewPassword = !showConfirmNewPassword" class="input-group-pass-right">
                                                                <img v-if="!showConfirmNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                                <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <p v-if="errorMessage" class="text-danger-login fw-600 fs-14" style="margin-top: 4px !important;" >{{errorMessage}}</p>
                                                </div>
                                            </div>
                                            <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel">Cancel</button>
                                                <button class="btn newsign-in text-capitalize"  @click="resetPassword" :disabled="ajax_progress" >Confirm 
                                                    <div class="digi-table-loader digi-button-loader-pos" v-if = "ajax_progress" >
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activediv == 'reset successfull'" class="middle px-10 w-100" style="height:100%;">
                                        <div class="middle-left"></div>
                                        <div class="flex-column text-center">
                                            <img class="mb-2" style="height: 6em;" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/parrot.svg" alt="parrot">
                                            <p class="text-default-heading text-center mb-5 text-white" style="font-size: 30px; font-weight: 700;">Success</p>
                                            <p v-if="is_using_mobile" class="text-default-heading text-center mb-7 text-white" style="font-size: 16px;">Your password has been successfully changed. A confirmation has been sent to your phone number at <span class="text-white fw-600">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.slice(-4)}}</span></p>
                                            <p v-if="is_using_email" class="text-default-heading text-center mb-7 text-white" style="font-size: 16px;">Your password has been successfully changed. A confirmation has been sent to your email address at <span class="text-white fw-600">{{reset_password_success_email}}</span></p>
                                            <!-- <span class="text-center" v-if="product_name == 'DigiExpense'">
                                                <button class="btn newsign-in text-capitalize" style="min-width: 110px; width: 160px !important;" :disabled="resend_btn_disable" @click="resetSuccessfullExpense">OK</button>
                                            </span> -->
                                            <span class="text-center">
                                                <button class="btn newsign-in text-capitalize" style="min-width: 110px; width: 160px !important;" :disabled="resend_btn_disable" @click="resetSuccessfull">OK</button>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="followus-login mt-3 mb-2">
                                        Follow us
                                    </div>
                                    <div class="d-flex justify-content-center pb-15px">
                                        <a href="https://www.facebook.com/digicollectllc/" target="_blank" class="btn btn-white rounded-circle btn-text-facebook me-1_5 waves-effect">
                                            <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/facebook.png" class="img-social facesoc" />
                                        </a>

                                        <a href="https://in.linkedin.com/company/digicollect-gis" target="_blank" class="btn btn-white rounded-circle btn-text-twitter me-1_5 waves-effect">
                                            <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/linkedin.png" class="img-social" />
                                        </a>

                                        <a href="https://x.com/digicollectllc/status/816509466661322753" target="_blank" class="btn btn-white rounded-circle btn-text-github me-1_5 waves-effect">
                                            <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/twitter-x.png" class="img-social" />
                                        </a>

                                        <a href="https://www.instagram.com/digicollect/?hl=en" target="_blank" class="btn btn-white rounded-circle btn-text-google-plus waves-effect">
                                            <img src="https://cdn.digicollect.com/cdn/digi_facelift/static/images/insta.png" class="img-social" />
                                        </a>
                                    </div>
                                    <div class="" style="color: #fff;text-align: center;">
                                        <span class="fs-12 fw-600 disable-select">© Copyright 2014 - {{ new Date().getFullYear() }} DigiCollect - All Rights Reserved.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div style="position: absolute;bottom: 15px;left: 0px;right: 0px;">
                        <div class="mt-5" style="color: #fff;text-align: center;">
                            <span class="fs-14 fw-600 disable-select">© Copyright 2014 - {{ new Date().getFullYear() }} DigiCollect - All Rights Reserved.</span>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { HollowDotsSpinner } from "epic-spinners";
// import auth from '../mixins/auth';
import auth from '@/components/mixins/auth';
import global from '../globals';
import PasswordMeter from "@/components/PasswordMeter.vue";
import { HalfCircleSpinner } from "epic-spinners";
export default {
    props:[], 
    data() {
        return {
            product_name: "DigiAdmin",
            bgCover: "background: url('/static/images/newlogin.svg') left center no-repeat;",
            loginPage: "crm",
            account_type: "Personal",
            min_pwd_length: false,
            is_uppercase_pwd: false,
            is_number_pwd: false,
            is_special_character_pwd: false,
            enter_pass_screen: false,
            sign_in_using_otp: false,
            otp_signin_btn: false,
            show_countdown: false,
            enter_email_screen: true,
            two_factor_authentication: false,
            is_two_factor_authentication: true,
            two_factor_auth_pass_screen_active: true,
            user_not_verified: false,
            is_email_phone_valid: false,
            is_email_phone_valid_text: '',
            password_error_text: '',
            login_type: '',
            login_btn_disable: false,
            resend_verification_link_success: '',
            code_resending: false,
            resend_code_success_text: '',
            otp_error_text: '',
            two_step_signed_in_otp: false,
            forget_pass_btn_disable: false,
            forgot_pass_otp_success: false,
            is_using_email: false,
            is_using_mobile: false,
            resend_btn_disable: false,
            is_email_phone_valid_text_forget_pass: '',
            ajax_progress: false,
            show_minutes: false,
            minutes_timeout_id: undefined,
            minutes: 899,
            countdownseconds: 60,
            password_button: false,
            login_id_true: false,
            oldlogin_id: true,
            btn_loader_disable: true,
            two_step_varification_boolean: false,
            is_email_valid_text: '',
            ajax_progress_otp: false
        }
    },
    mixins: [auth],
    components: {
        HollowDotsSpinner,
        PasswordMeter,
        HalfCircleSpinner
    },
    mounted(){
    },
    created() {
        if (this.$cookie.get("Token") && this.$route.path == '/login') {
            this.$router.push("/");
        }
        const dict = {
            custom: {
                new_password: {
                    min: () => "Minimum 8 characters",
                    regex: () => "Invalid format",
                },
            }
        };
        this.$validator.localize("en", dict);
    },
    methods: {
        checkUserIdEmpty(){
            this.login_id_true = false
            this.oldlogin_id = true
            this.form.login_id = ""
        },
        checkUserIdback(){
            console.log("checkuserid")
            this.login_id_true = false
            this.oldlogin_id = true
            this.is_email_phone_valid_text_forget_pass = ''

        },
        async loginCheckmail() {
            try{
                if (this.form.login_id.match(/[A-Za-z]/g)) {
                    this.login_type = 'email';
                    let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
                    if (!check) {
                        this.is_email_valid = true;
                        this.is_email_valid_text = "Please Enter a Valid Email Address";
                        this.is_email_phone_valid_text_forget_pass = ''
                    } else {
                        this.is_email_valid = false;
                        this.is_email_valid_text = "";
                        let params = {
                            login_id: this.form.login_id
                        }
                        if(this.product_name == 'DigiCloud'){
                            await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                                if(response.data.status_id == 1) {
                                    this.login_id_true = true
                                    this.oldlogin_id = false
                                    this.form.login_id == '';
                                    this.ajax_progress = false
                                }
                            }).catch((err)=>{
                                this.ajax_progress = false
                                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                                    this.enter_email_screen = false;
                                    this.user_not_verified = true;
                                }else {
                                    this.is_email_phone_valid = true;
                                }
                            });
                        }else{
                            await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                                if(response.data.status_id == 1) {
                                    this.login_id_true = true
                                    this.oldlogin_id = false
                                    this.form.login_id == '';
                                    this.ajax_progress = false
                                }
                            }).catch((err)=>{
                                this.ajax_progress = false
                                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                                    this.enter_email_screen = false;
                                    this.user_not_verified = true;
                                }else {
                                    this.is_email_phone_valid = true;
                                }
                            });
                        }
                        
                    }
                } 
            } catch(err){
                this.ajax_progress = false
                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                    this.enter_email_screen = false;
                    this.user_not_verified = true;
                }else {
                    this.is_email_phone_valid = true;
                }
            }
        },
        countDownMinutes() {
            this.show_minutes = true
            if(this.countdownseconds == 0){
                this.countdownseconds = 60;
            }
            if (this.minutes > 0) {
                this.minutes_timeout_id = setTimeout(() => {
                    this.minutes -= 1;
                    this.countdownseconds -=1;
                    this.countDownMinutes();
                }, 1000);
            } else if (this.minutes === 0) {
                this.show_minutes = false
                this.countdownseconds = 0;
                this.is_using_email = false
                this.is_using_mobile = false
            }
        },
        forgotPasswordCancel(){
            if(this.form.login_id == ''){
                this.activediv = 'login';
                this.login_id_true = false
                this.oldlogin_id = true
                this.enter_email_screen = true;
                this.two_factor_authentication= false,
                this.is_email_phone_valid_text_forget_pass = ''

            }else {
                this.form.password = '';
                this.confirmPassword= '';
                this.activediv = 'login';
                this.enter_email_screen = false;
                this.login_btn_disable = false;
                this.forget_pass_btn_disable = false;
                this.is_two_factor_authentication = true;
                this.two_factor_auth_pass_screen_active = true;
                this.forgot_pass_otp_success = false;
                this.is_email_phone_valid_text_forget_pass = ''
                if(this.two_step_varification_boolean) {
                    this.two_factor_authentication = true;
                    this.enter_pass_screen = false;
                } else {
                    this.two_factor_authentication = false;
                    this.enter_pass_screen = true;
                }
            }
            
        },
        cancelPassScreen() {
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.login_btn_disable = false;
        },
        cancelOtpScreen() {
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.sign_in_using_otp = false;
            this.login_btn_disable = false;
            this.two_factor_authentication = false;
        },
        cancelTwoFactor() {
            this.two_factor_authentication = false;
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.login_btn_disable = false;

        },
        checkUserId() {
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            } else {
                this.login_type = 'phone';
                let check = this.form.login_id.match(/^\d{10}$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            }
        },
        goToNext(type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            // if (this.form.login_id.match(/[A-Za-z]/g)) {
            //     this.login_type = 'email';
            //     let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
            //     if (!check) {
            //         this.is_email_valid = true;
            //         this.is_email_phone_valid = true;
            //         this.is_email_phone_valid_text = "Please Enter a Valid Email Address";
            //         this.is_email_phone_valid_text_forget_pass = ''
            //     } else {
            //         this.is_email_valid = false;
            //         this.is_email_valid_text = "";  
            //     }
            // }
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                    if(this.form.login_id == ''){
                        this.is_email_valid_text = false
                    }
                } else {
                    this.is_email_phone_valid = false;
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";  
                    if(type == 'login') {
                        this.two_factor_auth_pass_screen_active = true
                        this.loginCheck();
                        this.form.password = '';
                    }
                    else {
                        this.is_using_email = true;
                        this.is_using_mobile = false;
                        this.getOtpForgetPass('send');
                    }
                }
            } else {
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = "Please Enter a Email Address";
                    if(this.form.login_id == ''){
                        this.is_email_valid_text = false
                    }
                    this.is_email_phone_valid_text_forget_pass = 'Please Enter a Email Address'
                } else {
                    this.is_email_phone_valid = false;
                    if(type == 'login') {
                        this.$nextTick(() => {
                            this.$refs.password.focus();
                        });
                        this.two_factor_auth_pass_screen_active = true
                        this.loginCheck();
                        this.form.password = '';
                    }
                    else {
                        this.is_using_email = true;
                        this.is_using_mobile = false;
                        this.getOtpForgetPass('send');
                    }
                }
            }
        },
        async loginCheckOtp() {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            let check
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                    if(this.form.login_id == ''){
                        this.is_email_valid_text = false
                    }
                }
            }
            if(check){
                try{
                    this.login_btn_disable = true;
                    this.ajax_progress_otp = true
                    let params = {
                        login_id: this.form.login_id
                    }
                    if(this.product_name == 'DigiCloud'){
                        await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                            if(response.data.status_id == 1) {
                                this.goToOtpLoginNew('send')
                                // this.form.login_id == '';
                                // this.login_id_true = true;
                                // this.oldlogin_id = false;
                                // if(response.data.is_two_step_verification == true) {
                                //     this.two_step_varification_boolean = response.data.is_two_step_verification
                                //     this.two_factor_authentication = true;
                                //     this.enter_email_screen = false;
                                //     this.sign_in_using_otp = false;
                                // }
                                // else {
                                //     this.enter_pass_screen = true;
                                //     this.enter_email_screen = false;
                                
                                // }
                                this.ajax_progress_otp = false
                            }else{

                            }
                        }).catch((err)=>{
                            this.login_btn_disable = false;
                            this.ajax_progress_otp = false
                            if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                                this.enter_email_screen = false;
                                this.user_not_verified = true;
                            }else {
                                this.is_email_phone_valid = true;
                                this.is_email_phone_valid_text = err.response.data.reason;
                            }
                        });
                    }else{
                        await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                            if(response.data.status_id == 1) {
                                this.goToOtpLoginNew('send')
                                // this.form.login_id == '';
                                // this.login_id_true = true;
                                // this.oldlogin_id = false;
                                // if(response.data.is_two_step_verification == true) {
                                //     this.two_step_varification_boolean = response.data.is_two_step_verification
                                //     this.two_factor_authentication = true;
                                //     this.enter_email_screen = false;
                                //     this.sign_in_using_otp = false;
                                // }
                                // else {
                                //     this.enter_pass_screen = true;
                                //     this.enter_email_screen = false;
                                
                                // }
                                this.ajax_progress_otp = false
                            }
                        }).catch((err)=>{
                            this.login_btn_disable = false;
                            this.ajax_progress_otp = false
                            if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                                this.enter_email_screen = false;
                                this.user_not_verified = true;
                            }else {
                                this.is_email_phone_valid = true;
                                this.is_email_phone_valid_text = err.response.data.reason;
                            }
                        });
                    }
                } catch(err){
                    this.login_btn_disable = false;
                    this.ajax_progress = false
                    if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                        this.enter_email_screen = false;
                        this.user_not_verified = true;
                    }else {
                        this.is_email_phone_valid = true;
                        this.is_email_phone_valid_text = err.response.data.reason;
                    }
                }
            }
        },
        async loginCheck() {
            try{
                this.login_btn_disable = true;
                this.ajax_progress = true
                let params = {
                    login_id: this.form.login_id
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                        if(response.data.status_id == 1) {
                            
                            // this.form.login_id == '';
                            this.login_id_true = true;
                            this.oldlogin_id = false;
                            if(response.data.is_two_step_verification == true) {
                                this.two_step_varification_boolean = response.data.is_two_step_verification
                                this.two_factor_authentication = true;
                                this.enter_email_screen = false;
                                this.sign_in_using_otp = false;
                            }
                            else {
                                this.enter_pass_screen = true;
                                this.enter_email_screen = false;
                            
                            }
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.login_btn_disable = false;
                        this.ajax_progress = false
                        if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                            this.enter_email_screen = false;
                            this.user_not_verified = true;
                        }else {
                            this.is_email_phone_valid = true;
                            this.is_email_phone_valid_text = err.response.data.reason;
                        }
                    });
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                        if(response.data.status_id == 1) {
                            
                            // this.form.login_id == '';
                            this.login_id_true = true;
                            this.oldlogin_id = false;
                            if(response.data.is_two_step_verification == true) {
                                this.two_step_varification_boolean = response.data.is_two_step_verification
                                this.two_factor_authentication = true;
                                this.enter_email_screen = false;
                                this.sign_in_using_otp = false;
                            }
                            else {
                                this.enter_pass_screen = true;
                                this.enter_email_screen = false;
                            
                            }
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.login_btn_disable = false;
                        this.ajax_progress = false
                        if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                            this.enter_email_screen = false;
                            this.user_not_verified = true;
                        }else {
                            this.is_email_phone_valid = true;
                            this.is_email_phone_valid_text = err.response.data.reason;
                        }
                    });
                }
            } catch(err){
                this.login_btn_disable = false;
                this.ajax_progress = false
                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                    this.enter_email_screen = false;
                    this.user_not_verified = true;
                }else {
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = err.response.data.reason;
                }
            }
        },
        cancelResendLink() {
            if(this.product_name == 'DigiExpense'){
                window.location.href = global.EXPENSE_URL;
            } else if(this.product_name == 'DigiHelp'){
                window.location.href = global.HELP_URL;
            } else if(this.product_name == 'digiHRMS'){
                window.location.href = global.HRMS_URL;
            } else if(this.product_name == 'DigiCloud'){
                window.location.href = global.CLOUD_URL;
            } else if(this.product_name == 'DigiAdmin'){
                window.location.href = global.AUTH_URL;
            }
        },
        async resendUserVerifyLink() {
            try{
                this.resend_btn_disable = true;
                let params = {
                    login_id: this.form.login_id,
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/registration/resend/link", params).then((response) => {
                        let res = response.data
                        if(res.status_id == 1) {
                            this.resend_verification_link_success = res.response;
                            setTimeout(() => {
                                this.resend_verification_link_success = '';
                                window.location.href = global.HELP_URL;
                            }, 2000);
                        }
                    }).catch((err)=>{
                        this.resend_verification_link_success = err.response.data.reason;
                        this.resend_btn_disable = false;
                    });
                }else{
                    await this.$http.post(global.ADMIN_API + "/registration/resend/link", params).then((response) => {
                        let res = response.data
                        if(res.status_id == 1) {
                            this.resend_verification_link_success = res.response;
                            setTimeout(() => {
                                this.resend_verification_link_success = '';
                                if(this.product_name == 'DigiExpense'){
                                    window.location.href = global.EXPENSE_URL;
                                } else if(this.product_name == 'DigiHelp'){
                                    window.location.href = global.HELP_URL;
                                } else if(this.product_name == 'digiHRMS'){
                                    window.location.href = global.HRMS_URL;
                                } else if(this.product_name == 'DigiCloud'){
                                    window.location.href = global.CLOUD_URL;
                                } else if(this.product_name == 'DigiAdmin'){
                                    window.location.href = global.AUTH_URL;
                                }
                            }, 2000);
                        }
                    }).catch((err)=>{
                        this.resend_verification_link_success = err.response.data.reason;
                        this.resend_btn_disable = false;
                    });
                }
                
            } catch(err){
                this.resend_verification_link_success = err.response.data.reason;
                this.resend_btn_disable = false;
            }
        },
        async loginUsingPassword(type) {
            try{
                if(this.form.password.length == 0) {
                    this.password_error_text = 'Please Enter a Password';
                }
                else {
                    this.signedIn = true;
                    let params = {
                        login_id: this.form.login_id,
                        password: this.form.password
                    }
                    if(this.product_name == 'DigiCloud'){
                        await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                            this.ajax_progress = true
                            if(response.data.status_id == 1) {
                                if(type == 'one-step') {
                                    if(response.data.token) {
                                        this.$cookie.set("Token", response.data.token, {
                                            expires: 7,
                                            domain: "digicollect.com",
                                        });
                                        this.$cookie.set("session_id", response.data.session_id, {
                                            expires: 7,
                                            domain: "digicollect.com",
                                        });
                                        if (this.$route.query.redirect_to) {
                                            window.location.href = this.$route.query.redirect_to;
                                        } else {
                                            this.$store.commit("setToken", response.data.token);
                                            if(this.product_name == 'DigiExpense'){
                                                window.location.href = global.EXPENSE_URL;
                                            } else if(this.product_name == 'DigiHelp'){
                                                window.location.href = global.HELP_URL;
                                            } else if(this.product_name == 'digiHRMS'){
                                                window.location.href = global.HRMS_URL;
                                            } else if(this.product_name == 'DigiCloud'){
                                                window.location.href = global.CLOUD_URL;
                                            } else if(this.product_name == 'DigiAdmin'){
                                                window.location.href = global.AUTH_URL;
                                            }
                                        }
                                    }
                                    this.ajax_progress = false
                                }
                                else if(type == 'two-step') {
                                    if(response.data.message == 'Please Enter Otp For Verification.' || response.data.is_two_step_verification == true) {
                                        this.two_factor_auth_pass_screen_active = false;
                                        this.enter_pass_screen= false;
                                        // sign_in_using_otp
                                        this.countDownTimer();
                                        this.signedIn = false;                                }
                                    this.ajax_progress = false
                                }
                            }
                        }).catch((err)=>{
                            this.password_error_text = err.response.data.reason;
                            this.ajax_progress = false
                            this.signedIn = false;
                            if(type == 'two-step'){
                                this.enter_pass_screen= false;
                                this.two_factor_authentication = true;
                                this.form.password = "";
                            }
                            else {
                                this.two_factor_authentication = false;
                                this.enter_pass_screen= true;
                                this.form.password = "";
                            }
                        });
                    }else{
                        await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                            this.ajax_progress = true
                            if(response.data.status_id == 1) {
                                if(type == 'one-step') {
                                    if(response.data.token) {
                                        this.$cookie.set("Token", response.data.token, {
                                            expires: 7,
                                            domain: "digicollect.com",
                                        });
                                        this.$cookie.set("session_id", response.data.session_id, {
                                            expires: 7,
                                            domain: "digicollect.com",
                                        });
                                        if (this.$route.query.redirect_to) {
                                            window.location.href = this.$route.query.redirect_to;
                                        } else {
                                            this.$store.commit("setToken", response.data.token);
                                            if(this.product_name == 'DigiExpense'){
                                                window.location.href = global.EXPENSE_URL;
                                            } else if(this.product_name == 'DigiHelp'){
                                                window.location.href = global.HELP_URL;
                                            } else if(this.product_name == 'digiHRMS'){
                                                window.location.href = global.HRMS_URL;
                                            } else if(this.product_name == 'DigiCloud'){
                                                window.location.href = global.CLOUD_URL;
                                            } else if(this.product_name == 'DigiAdmin'){
                                                window.location.href = global.AUTH_URL;
                                            }
                                        }
                                    }
                                    this.ajax_progress = false
                                }
                                else if(type == 'two-step') {
                                    if(response.data.message == 'Please Enter Otp For Verification.' || response.data.is_two_step_verification == true) {
                                        this.two_factor_auth_pass_screen_active = false;
                                        this.enter_pass_screen= false;
                                        // sign_in_using_otp
                                        this.countDownTimer();
                                        this.signedIn = false;                                }
                                    this.ajax_progress = false
                                }
                            }
                        }).catch((err)=>{
                            this.password_error_text = err.response.data.reason;
                            this.ajax_progress = false
                            this.signedIn = false;
                            if(type == 'two-step'){
                                this.enter_pass_screen= false;
                                this.two_factor_authentication = true;
                                this.form.password = "";
                            }
                            else {
                                this.two_factor_authentication = false;
                                this.enter_pass_screen= true;
                                this.form.password = "";
                            }
                        });

                    }
                    
                }
                // this.form.password='';
            } catch(err){
                console.log("err")
                this.password_error_text = err.response.data.reason;
                this.ajax_progress = false
                this.signedIn = false;
                this.form.password = "";
                this.two_factor_authentication = true
                if(type == 'two-step'){
                            this.enter_pass_screen= false;
                        }
                
            }
        },
        async loginUsingOtp(value, type) {
            this.errorMessage = "";
            this.otp_error_text = '';
            this.otpInvalid = false;
            this.otpValue = value;
            this.otp_signin_btn = true;
            try{
                if(type == 'one-step') {
                    this.signedIn = true;
                }
                else {
                    this.two_step_signed_in_otp = true;
                }
                let params = {
                    login_id: this.form.login_id,
                    otp: this.otpValue
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                        if(response.data.status_id == 1 && response.data.token) {
                            this.ajax_progress = true
                            this.$cookie.set("Token", response.data.token, {
                                expires: 7,
                                domain: "digicollect.com",
                            });
                            this.$cookie.set("session_id", response.data.session_id, {
                                expires: 7,
                                domain: "digicollect.com",
                            });
                            if (this.$route.query.redirect_to) {
                                window.location.href = this.$route.query.redirect_to;
                            } else {
                                this.$store.commit("setToken", response.data.token);
                                if(this.product_name == 'DigiExpense'){
                                    window.location.href = global.EXPENSE_URL;
                                } else if(this.product_name == 'DigiHelp'){
                                    window.location.href = global.HELP_URL;
                                } else if(this.product_name == 'digiHRMS'){
                                    window.location.href = global.HRMS_URL;
                                } else if(this.product_name == 'DigiCloud'){
                                    window.location.href = global.CLOUD_URL;
                                } else if(this.product_name == 'DigiAdmin'){
                                    window.location.href = global.AUTH_URL;
                                }
                            }
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.otpInvalid = true;
                        this.ajax_progress = false
                        this.otp_error_text = err.response.data.reason;
                        if(type == 'one-step') {
                            this.signedIn = false;
                            this.handleClearInput();
                        }
                        else {
                            this.two_step_signed_in_otp = false;
                            this.handleClearInput();
                        }
                        this.otpValue = "";
                    })
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                        if(response.data.status_id == 1 && response.data.token) {
                            this.ajax_progress = true
                            this.$cookie.set("Token", response.data.token, {
                                expires: 7,
                                domain: "digicollect.com",
                            });
                            this.$cookie.set("session_id", response.data.session_id, {
                                expires: 7,
                                domain: "digicollect.com",
                            });
                            if (this.$route.query.redirect_to) {
                                window.location.href = this.$route.query.redirect_to;
                            } else {
                                this.$store.commit("setToken", response.data.token);
                                if(this.product_name == 'DigiExpense'){
                                    window.location.href = global.EXPENSE_URL;
                                } else if(this.product_name == 'DigiHelp'){
                                    window.location.href = global.HELP_URL;
                                } else if(this.product_name == 'digiHRMS'){
                                    window.location.href = global.HRMS_URL;
                                } else if(this.product_name == 'DigiCloud'){
                                    window.location.href = global.CLOUD_URL;
                                } else if(this.product_name == 'DigiAdmin'){
                                    window.location.href = global.AUTH_URL;
                                }
                            }
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.otpInvalid = true;
                        this.ajax_progress = false
                        this.otp_error_text = err.response.data.reason;
                        if(type == 'one-step') {
                            this.signedIn = false;
                            this.handleClearInput();
                        }
                        else {
                            this.two_step_signed_in_otp = false;
                            this.handleClearInput();
                        }
                        this.otpValue = "";
                    })
                }
            } catch(err) {
                this.otpInvalid = true;
                this.ajax_progress = false
                this.otp_error_text = err.response.data.reason;
                if(type == 'one-step') {
                    this.signedIn = false;
                    this.handleClearInput();
                }
                else {
                    this.two_step_signed_in_otp = false;
                    this.handleClearInput();
                }
                this.otpValue = "";
            }
        },
        handleClearInput() {
            this.$refs.otpInput.clearInput();
        },
        otpInputActive() {
            this.loginUsingPassword('two-step');
            this.password_button = false
            clearTimeout(this.minutes_timeout_id);
            this.minutes = 899;
            this.countdown = 59;
            this.countdownseconds = 60;
            this.countDownMinutes();
            // this.form.password = '';
        },
        async goToOtpLogin(type, new_type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            if(type == 'send') {
                this.sign_in_using_otp = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
                if(new_type && new_type =='two-factor-otp') {
                    this.password_button = true
                    this.two_factor_auth_pass_screen_active = false
                }
            }
            if(type == 'resend') {
                this.code_resending = true;
                this.otpInvalid = false;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            this.countDownTimer();
            try {
                let params = {
                    login_id: this.form.login_id,
                    otp_for: 'login'
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response) => {
                        if(response.data.status_id == 1) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        } else if(response.data.status_id == 0) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.reason;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        }
                    }).catch((err)=>{
                        if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                    });
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response) => {
                        if(response.data.status_id == 1) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        } else if(response.data.status_id == 0) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.reason;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        }
                    }).catch((err)=>{
                        if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                    });
                }
            }
            catch(err) {
                if(type == 'resend') {
                    this.resend_code_success_text = err.response.data.reason;
                    setTimeout(() => {
                        this.resend_code_success_text = '';
                    }, 2000);
                    this.code_resending = false;
                }
            }
        },
        async goToOtpLoginNew(type, new_type) {
            this.ajax_progress_otp = true
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            if(type == 'send') {
                this.enter_email_screen = false
                this.enter_pass_screen = true
                this.sign_in_using_otp = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
                if(new_type && new_type =='two-factor-otp') {
                    this.password_button = true
                    this.two_factor_auth_pass_screen_active = false
                }
            }
            this.countDownTimer();
            try {
                let params = {
                    login_id: this.form.login_id,
                    otp_for: 'login'
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response) => {
                        if(response.data.status_id == 1) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        } else if(response.data.status_id == 0) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.reason;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        }
                    }).catch((err)=>{
                        if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                    });
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response) => {
                        if(response.data.status_id == 1) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        } else if(response.data.status_id == 0) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.reason;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        }
                    }).catch((err)=>{
                        if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                    });
                }
                this.ajax_progress_otp = false
            }
            catch(err) {
                this.ajax_progress_otp = false
                if(type == 'resend') {
                    this.resend_code_success_text = err.response.data.reason;
                    setTimeout(() => {
                        this.resend_code_success_text = '';
                    }, 2000);
                    this.code_resending = false;
                }
            }
        },
        goToPassLogin(new_type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            this.sign_in_using_otp = false;
            if(new_type && new_type =='two-factor-password') {
                this.two_factor_auth_pass_screen_active = true
            }
        },
        onPassInput(e) {
            if(e.target.value.match(/^(?=.{8,}$)/)) {
                this.min_pwd_length = true;
            }
            else {
                this.min_pwd_length = false;
            }
            if(e.target.value.match(/^(?=.*[A-Z])/)) {
                this.is_uppercase_pwd = true;
            } else {
                this.is_uppercase_pwd = false;
            }
            if(e.target.value.match(/^(?=.*[0-9])/)) {
                this.is_number_pwd = true;
            } else {
                this.is_number_pwd = false;
            }
            if(e.target.value.match(/^(?=.*[!@#$%^&*()])/)) {
                this.is_special_character_pwd = true;
            } else {
                this.is_special_character_pwd = false;
            }
        },

        async getOtpForgetPass(type) {
            if(type == 'send') {
                this.forget_pass_btn_disable = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            else {
                this.code_resending = true;
                this.otpInvalid = false;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            this.countDownTimer();
            try{
                let params = {
                    login_id: this.form.login_id,
                    otp_for: 'reset'
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response)=>{
                        if(response.data.status_id == 1) {
                            this.ajax_progress = true
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                            else {
                                this.activediv = 'verify otp';
                            }
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.forget_pass_btn_disable = false;
                        this.ajax_progress = false
                        if(type == 'send') {
                            this.is_email_phone_valid_text_forget_pass = err.response.data.reason;
                        } else if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                        }
                    });
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response)=>{
                        if(response.data.status_id == 1) {
                            this.ajax_progress = true
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                            else {
                                this.activediv = 'verify otp';
                            }
                            this.ajax_progress = false
                        }
                    }).catch((err)=>{
                        this.forget_pass_btn_disable = false;
                        this.ajax_progress = false
                        if(type == 'send') {
                            this.is_email_phone_valid_text_forget_pass = err.response.data.reason;
                        } else if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                        }
                    });
                }
            } catch(err) {
                this.forget_pass_btn_disable = false;
                this.ajax_progress = false
                if(type == 'send') {
                    this.is_email_phone_valid_text_forget_pass = err.response.data.reason;
                } else if(type == 'resend') {
                    this.resend_code_success_text = err.response.data.reason;
                }
            }
        },
        forgotPassword(){
            this.activediv = 'forgot password'
            this.$nextTick(() => {
                this.$refs.forgot.focus();
            });  
        },
        async verifyOtpForgotPass(value) {
            this.errorMessage = "";
            this.otp_error_text = '';
            this.otpInvalid = false;
            this.otpValue = value;
            this.otp_signin_btn = true;
            try {
                this.forgot_pass_otp_success = true;
                let params = {
                    login_id: this.form.login_id,
                    otp: this.otpValue,
                    otp_for: 'reset'
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/otp/verify", params).then((response)=>{
                        this.ajax_progress = true
                        if(response.data.status_id == 1 ) {
                            this.activediv = 'set new password';
                        }
                        this.ajax_progress = false
                    }).catch((err)=>{
                        this.otp_error_text = err.response.data.reason;
                        this.ajax_progress = false
                        this.otpInvalid = true;
                        this.otpValue = "";
                        this.forgot_pass_otp_success = false;
                    })
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/otp/verify", params).then((response)=>{
                        this.ajax_progress = true
                        if(response.data.status_id == 1 ) {
                            this.activediv = 'set new password';
                        }
                        this.ajax_progress = false
                    }).catch((err)=>{
                        this.otp_error_text = err.response.data.reason;
                        this.ajax_progress = false
                        this.otpInvalid = true;
                        this.otpValue = "";
                        this.forgot_pass_otp_success = false;
                    })
                }
            } catch(err){
                this.otp_error_text = err.response.data.reason;
                this.ajax_progress = false
                this.otpInvalid = true;
                this.otpValue = "";
                this.forgot_pass_otp_success = false;
            }
        },
        async resetPasswordConfirm() {
            try {
                this.ajax_progress = true
                let params = {
                    login_id: this.form.login_id,
                    password: this.form.password
                }
                if(this.product_name == 'DigiCloud'){
                    await this.$http.post(global.ADMIN_API + "/auth/reset", params).then((response) => {
                        if(response.data.status_id == 1) {
                            this.activediv = "reset successfull";
                        }
                        this.ajax_progress = false
                    }).catch((err) => {
                        this.ajax_progress = false
                        this.errorMessage = err.response.data.reason;
                    })
                }else{
                    await this.$http.post(global.ADMIN_API + "/auth/reset", params).then((response) => {
                        if(response.data.status_id == 1) {
                            this.activediv = "reset successfull";
                        }
                        this.ajax_progress = false
                    }).catch((err) => {
                        this.ajax_progress = false
                        this.errorMessage = err.response.data.reason;
                    })
                    
                } 
            } catch(err){
                this.ajax_progress = false
                this.errorMessage = err.response.data.reason;
            }
        },
        async resetPassword() {
            this.$validator.validateAll().then(async result => {
                if (result && this.form.password && this.confirmPassword === this.form.password && !this.errorMessage) {
                    this.resetPasswordConfirm();
                } else if (!this.form.password || !this.confirmPassword) {
                    this.errorMessage = "Please fill both fields";
                } else if(this.confirmPassword !== this.form.password) {
                    this.errorMessage = "Confirm Password not Matched";
                }
            })
        }
    },
    computed: {
        // <p v-if="is_using_mobile" class="text-default-heading text-center mb-7 text-white" style="font-size: 16px;">Your password has been successfully changed. A confirmation has been sent to your phone number at <span class="text-white fw-600">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.slice(-4)}}</span></p>
        //                                     <p v-if="is_using_email" class="text-default-heading text-center mb-7 text-white" style="font-size: 16px;">Your password has been successfully changed. A confirmation has been sent to your email address at <span class="text-white fw-600">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.split("@")[0].slice(-2)}}@{{form.login_id.split("@")[1]}}</span></p>
        reset_password_success_email(){
            if(this.is_using_mobile){
                return this.form.login_id.slice(0,2) + 'XXXXXX' + this.form.login_id.slice(-4)
            }
            let login_user = this.form.login_id.split("@")[0]
            let middleTextLength = login_user.slice(1, login_user.length - 1).length
            let middleText = ''
            for (let i = 0; i < middleTextLength; i++) {
                middleText += 'X'
            }
            return login_user[0] + middleText + login_user.slice(-1) + '@' + this.form.login_id.split("@")[1]
        }
    },
    watch: {
        "$route.path": function (path) {
            if (this.$cookie.get("Token") && path == '/login') {
                this.$router.push("/");
            }
        },
    }
}
</script>

<style scoped>
    .text-underline{
        text-decoration: underline !important;
    }
    .scroll-overflow{
        overflow:scroll;
    }
    .font-size-header{
        font-size: 30px;
    }
    .width-leftbox{
        width:100%;
    }
    .text-default-blue {
        color: white !important;
        font-weight: 600;
    }

    .disable-select{
        -webkit-user-select: none;
    }
    .digi-button-loader-pos{
        position: absolute;
        top: -11px;
        left: 37px;
    }     
    .highlighted-white {
        color: #ffffff !important;
        padding-bottom: 5px;
        text-decoration: none !important;
        text-decoration-thickness: 0px !important;
    }
    .full-width-text {
        display: block;  
        width: 100%;     
        word-wrap: break-word;
        /* word-break: break-all; */
        white-space: pre-wrap;
        text-align: justify !important; 
    }

    .forgot-password{
        font-size: 35px;
    }
    .image-holder {
        width: 500px;
        background: #fff;
        height: 500px;
        border-radius: 50%;
        bottom: -90px;
        position: absolute;
        left: -60px;
    }
    .group-image {
        width: 350px;
        height: 350px;
        right: 60px;
        position: absolute;
        top: 60px;
    }
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 0px;
        padding-left: 80px;
        padding-right: 80px;
    }
    .middle-left {
        width: 50%;
    }
    .middle-right {
        width: 50%;
    }
    .star {
        font-size: 12px;
        color: #F44336;
        top:7px !important;
    }
    .bg-image{
        /* background-image: url("/static/images/login_bg1.png")left center no-repeat; */
    }
    .fs-24{
        font-size: 24px;
    }
    @media (min-width: 400px) {
        .right-box {
            width: 36rem;
            float: none;
        }
    }

    @media (min-width: 600px) {
        .right-box {
            width: 38rem;
            float: right;
        }
        .h-30-20-10rem {
            height: 10rem;
        }
        .h-30-18-10rem {
            height: 10rem;
        }
        .otp-input, .otp-input-warning {
            width: 44px !important;
            height: 44px !important;
            margin-right: 16px !important;
        }
    }

    @media (min-width: 960px) {
        .right-box {
            width: 40rem;
        }
        .h-30-20-10rem {
            height: 10rem;
        }
        .h-30-18-10rem {
            height: 13rem;
        }
    }
    @media (min-width: 1280px) {
        .right-box {
            width: 40rem;
        }
        .h-30-20-10rem {
            height: 10rem;
        }
        .h-30-18-10rem {
            height: 10rem;
        }
    }
    
    @media (min-width: 1400px) {
        .right-box {
            width: 44rem;
        }
        .h-30-20-10rem {
            height: 10rem;
        }
        .h-30-18-10rem {
            height: 10rem;
        }
    }
    .right-box {
        height: 100%;
        margin: 0px !important;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 16px;
        padding-bottom: 13px;
        object-fit: contain;
        border-radius: 23px;
        /* border: 1px solid #FFF; */
        /* border: 1px solid rgba(255, 255, 255, 0.); */
        /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); */
        /* background: rgba(255, 255, 255, 0.40); */
        /* background: linear-gradient(135deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.2) 100%);
        backdrop-filter: blur(7.5px);
        -webkit-backdrop-filter: blur(7.5px); */
        /* -webkit-backdrop-filter: blur(8.5px);
        backdrop-filter: blur(8.5px); */
        background: rgba(255, 255, 255, 0.1); /* Glass effect */
        backdrop-filter: blur(10px);
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }
    .text-center{
        text-align: center !important;
    }
    .sign-in{
        width: 130px;
        height: 40px;
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        color: #fff;
        font-weight: 800;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
    }
    .cancel{
        width: 130px;
        height: 40px;
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        color: #fff;
        font-weight: 800;
        border: 1px solid #94bbe3;
        background-color: #4789cd;
    }
    .newsign-in:disabled{
        width: 130px !important;
        height: 40px !important;
        text-align: center;
        padding: 0px !important;
        object-fit: contain !important;
        border: 2px solid #00000085 !important;
        color: #00000085 !important;
        font-weight: 600 !important;
        border-radius: 10px !important;
        -webkit-backdrop-filter: blur(20.7px) !important;
        backdrop-filter: blur(41px) !important;
        font-size: 16px !important;
        background-color: #ffffff9c  !important;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
        background-image: none !important;
    }
    @media (max-width: 1270px) {
        hr{
            display: none !important;
        }
    }
    .newcancel{
        width: 130px !important;
        height: 40px !important;
        text-align: center;
        -o-object-fit: contain !important;
        object-fit: contain !important;
        border: 2px solid #B20A36 !important;
        color: #fff !important;
        font-weight: 600 !important;
        border-radius: 10px !important;
        -webkit-backdrop-filter: blur(20.7px) !important;
        backdrop-filter: blur(41px) !important;
        font-size: 16px !important;
        background-color: #B20A36 !important;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
        background-image: none !important;
        padding-top: 0px
        /* width: 130px;
        height: 40px;
        padding: 4px 22px 4px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #fff;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff00;
        font-size: 16px !important; */
    }
    .newcancel:hover{
        width: 130px !important;
        height: 40px !important;
        text-align: center;
        -o-object-fit: contain !important;
        object-fit: contain !important;
        border: 2px solid #b20a3750 !important;
        color: #eee !important;
        font-weight: 600 !important;
        border-radius: 10px !important;
        -webkit-backdrop-filter: blur(20.7px) !important;
        backdrop-filter: blur(41px) !important;
        font-size: 16px !important;
        background-color: #b20a37ed !important;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
        background-image: none !important;
        padding-top: 0px
        /* width: 130px;
        height: 40px;
        padding: 4px 22px 4px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #f4f4f4;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        background: #B20A36;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
        font-size: 16px !important; */
    }
    .newsign-in{
        width: 130px !important;
        height: 40px !important;
        padding: 0px !important;
        text-align: center !important;
        object-fit: contain !important;
        border-radius: 10px !important;
        border: 2px solid #fff !important;
        color: #000 !important;
        font-weight: 600 !important;
        background: #fff !important;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
        font-size: 16px !important;
        background-image: none !important;
    }
    .newsign-in-btn{
        width: 190px !important;
        height: 40px !important;
        padding: 0px !important;
        text-align: center !important;
        object-fit: contain !important;
        border-radius: 10px !important;
        border: 2px solid #fff !important;
        color: #000 !important;
        font-weight: 800 !important;
        background: #fff !important;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
        font-size: 14px !important;
        background-image: none !important;
    }
    .newsign-in-btn:disabled{
        width: 190px !important;
        height: 40px !important;
        text-align: center;
        padding: 0px !important;
        object-fit: contain !important;
        border: 2px solid #00000085 !important;
        color: #00000085 !important;
        font-weight: 800 !important;
        border-radius: 10px !important;
        -webkit-backdrop-filter: blur(20.7px) !important;
        backdrop-filter: blur(41px) !important;
        font-size: 14px !important;
        background-color: #ffffff9c  !important;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
        background-image: none !important;
    }
    .resend-code{
        width: 120px;
        height: 34px;
        padding: 0 0px 0 0px;
        object-fit: contain;
        border-radius: 4px !important;
        color: #fff !important;
        font-weight: 800;
        /* border-radius: 13.5px; */
        /* -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px); */
        background-color: #2D837E !important;
    }
    .resend-code:disabled{
        width: 120px;
        height: 34px;
        padding: 0 0px 0 0px;
        object-fit: contain;
        border-radius: 4px !important;
        color: #fff !important;
        font-weight: 800;
        background-color: #ffffff78 !important;
    }
    @media only screen and (min-width: 0px) and (max-width: 768px){
        .newflex-reverse {
            display: flex;
            align-items: flex-start !important;
            position: relative;
            flex-direction: column-reverse !important;
        }
        .top{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 0px;
            padding-left: 10px;
            padding-right: 10px;
        }
        .right-box{
            margin: 0 auto;
        }
    }
    .bor-der::before {
        content: "";
        position: absolute;
        top: 100%;
        width: 100%;
        left: 0;
        height: 3px;
        border-radius: 2px;
        background: #fff;
    }
    .resend-code.resend-active {
        /* background-image: linear-gradient(to bottom, #91b9e2, #4d8cce); */
        color: #fff;
    } 

    /* login css */
    .main-bg {
        height: 100%;
        background-color: #fff;
    }
    @media (max-width: 1200px) {
        .inner-bg {
            background: #fff !important;
        }
        .main-bg {
            background: #fff !important;
        }
        .register-bg {
            background: #fff !important;
        }
        .dc {
            color: #00448b;
        }
        .copyright {
            color: #00448b !important;
        }
    }
    @media (max-height: 690px) {
        .inner-bg {
            background: #fff !important;
        }
        .main-bg {
            background: #fff !important;
        }
        .register-bg {
            background: #fff !important;
        }
        .dc {
            color: #00448b;
        }
        .copyright {
            color: #00448b !important;
        }
    }
    .hidden
    {
        display: none !important;
    }
    .min-w-0
    {
        min-width: 0px !important;
    }
    .flex
    {
        display: flex !important;
    }
    .relative
    {
        position: relative !important;
    }
    .w-1\/2
    {
        width: 50% !important;
    }
    .h-full
    {
        height: 100% !important;
    }
    .w-full
    {
        width: 100% !important;
    }
    .flex-auto
    {
        flex: 1 1 auto !important;
    }
    .flex-col
    {
        flex-direction: column !important;
    }
    .login-outlet {
        position: relative;
        display: flex;
        flex: 1 1 auto;
        width: 100%;
    }
    .items-center
    {
        align-items: center !important;
    }
    .dark\:border-r
    {
        border-right-width: 1px !important;
    }
    .overflow-hidden
    {
        overflow: hidden !important;
    }
    .justify-center
    {
        justify-content: center !important;
    }
    .justify-start
    {
        justify-content: start !important;
    }
    .justify-end
    {
        justify-content: end !important;
    }
    .justify-between
    {
        justify-content: space-between !important;
    }
    .flex-0
    {
        flex: 0 0 auto !important;
    }
    .flex-wrap
    {
        flex-wrap: wrap !important;
    }
    .p-16rem {
        padding: 4rem !important;
    }
    .otp-input {
        border: 1px solid rgba(0, 0, 0, 0.41) !important;
        width: 35px !important;
        height: 35px !important;
        border-radius: 5px !important;
        text-align: center !important;
        margin-right: 15px !important;
    }
    .otp-input-warning {
        border: 1px solid #ff3b3b !important;
        width: 35px !important;
        height: 35px !important;
        border-radius: 5px !important;
        text-align: center !important;
        margin-right: 15px !important;
    }
    @media (min-width: 600px) {
        .sm\:p-12{
            padding: 3rem !important;
        }
    .sm\:rounded-2xl
    {
        border-radius: 1rem !important;
    }
    .sm\:w-auto
    {
        width: auto !important;
    }
    .sm\:justify-center
    {
        justify-content: center !important;
    }
    .sm\:flex-row
    {
        flex-direction: row !important;
    }
    .otp-input, .otp-input-warning {
        width: 44px !important;
        height: 44px !important;
        margin-right: 16px !important;
        font-weight: 500;
    }
    }
    @media (min-width: 960px) {
        .md\:w-1\/2
        {
            width: 50% !important;
        }
        .md\:h-full
        {
            height: 100% !important;
        }
            .md\:flex
        {
            display: flex !important;
        }
            .md\:items-start
        {
            align-items: flex-start !important;
        }
        .md\:justify-start
        {
            justify-content: flex-start !important;
        }
        .md\:p-16
        {
            padding: 4rem !important;
        }
        .md\:p-16login
        {
            padding-left: 8rem !important;
            padding-right: 8rem !important;
            padding-top: 0rem !important;
            padding-bottom: 1rem !important;
        }
        .md\:rounded-none
        {
            border-radius: 0 !important;
        }
        .md\:justify-end
        {
            justify-content: flex-end !important;
        }
        .md\:items-center
        {
            align-items: center !important;
        }
        .otp-input, .otp-input-warning {
            width: 44px !important;
            height: 44px !important;
            margin-right: 16px !important;
        }
        .padding-x{
            padding-left: 7.9rem !important;
            padding-right: 5.4rem !important;
        }
        .width-leftbox{
            width:88% !important;
        }
    }
    @media (min-width: 1280px) {
        .lg\:px-28 {
            padding-left: 7rem !important;
            padding-right: 7rem !important;
        }
        .lg\:pxy-28login {
            padding-left: 7rem !important;
            padding-right: 7rem !important;
            padding-top: 0rem !important;
            padding-bottom: 1rem !important;
        }
        .pxy-28loginheader {
            padding-left: 7rem !important;
            padding-right: 7rem !important;
            padding-top: 4rem !important;
            padding-bottom: 2rem !important;
        }
        .otp-input, .otp-input-warning {
            width: 44px !important;
            height: 44px !important;
            margin-right: 16px !important;
        }
        .padding-x{
            padding-left: 6.9rem !important;
            padding-right: 4.4rem !important;

        }
        .width-leftbox[data-v-52c8a31a] {
            width: 88% !important;
        }
        .padding-bottom{
            padding-bottom: 1.0rem !important;
        }


    }
    @media (min-width: 1400px) {
        .lg\:pxy-28login {
            padding-left: 10rem !important;
            padding-right: 10rem !important;
            padding-top: 0rem !important;
            padding-bottom: 3rem !important;
        }
        .pxy-28loginheader {
            padding-left: 10rem !important;
            padding-right: 10rem !important;
            padding-top: 4rem !important;
            padding-bottom: 2rem !important;
        }
        .otp-input, .otp-input-warning {
            width: 44px !important;
            height: 44px !important;
            margin-right: 16px !important;
        }
        .padding-x{
            padding-left: 7.4rem !important;
            padding-right: 7.4rem !important;
        }
        .width-leftbox[data-v-52c8a31a] {
            width: 100% !important;
        }
        .padding-bottom{
            padding-bottom: 2.0rem !important;
        }
    }
    @media (min-width: 1600px) {
        
        .width-leftbox[data-v-52c8a31a] {
            width: 100% !important;
        }
        .right-box {
            width: 46rem;
        }
    }
    @media (min-width: 1700px) {
        .padding-bottom{
            padding-bottom: 5.4rem !important;
        }
    }


.app-brand {
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    line-height: 1;
    justify-content: center !important;
    padding-bottom: 10px;
}
.app-brand-link {
    display: flex;
    align-items: center;
}
.app-brand-logo.demo img.appbrand-logo {
    width: 46px;
    height: auto;
}
.text-shadow {
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.50);
}
.productbrand-name {
    color: #FFF;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    padding-bottom: 10px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.50);
    display: flex;
    align-content: center;
    justify-content: center;
    width: 100%;
}
.tagline-login {
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    padding-bottom: 10px !important;
    display: flex;
    align-content: center;
    justify-content: center;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
}
.input-group-login {
    position: relative;
    display: flex;
    align-items: stretch;
    width: 100%;
}
.input-group-pass-login {
    display: flex;
    align-items: center;
    padding: 2px 12px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    text-align: center;
    white-space: nowrap;
    background-color: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.28) !important;
    border-radius: 8px !important;
    border-top-right-radius: 0!important;
    border-bottom-right-radius: 0!important;
    border-right: 0px solid transparent !important; 
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.input-group-pass-right {
    display: flex;
    align-items: center;
    padding: 2px 12px;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.5;
    color: #000;
    text-align: center;
    white-space: nowrap;
    background-color: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.28) !important;
    border-radius: 8px !important;
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
    border-right: 0px solid transparent !important;
    border-left: 0px solid transparent !important;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.input-group-text-login {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.5;
    color: #000;
    text-align: center;
    white-space: nowrap;
    background-color: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.28) !important;
    border-radius: 8px !important;
    border-top-right-radius: 0!important;
    border-bottom-right-radius: 0!important;
    border-right: 0px solid transparent !important;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.form-control-login {
    display: block;
    width: 100%;
    padding: 10px 16px 10px 5px;
    font-size: 15px !important;
    font-weight: 600;
    line-height: 1.5;
    color: #fff !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.28) !important;
    border-radius: 8px !important;
    box-shadow: inset;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
    border-left: 0px solid transparent !important;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.input-group-login>.form-control, .input-group-login>.form-floating, .input-group-login>.form-select {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
}
.form-control-login-pass {
    display: block;
    width: 100%;
    padding: 10px 16px 10px 5px;
    font-size: 15px !important;
    font-weight: 600;
    line-height: 1.5;
    color: #fff !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.28) !important;
    box-shadow: inset;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
    border-left: 0px solid transparent !important;
    border-right: 0px solid transparent !important;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

input.form-control-login-pass::placeholder {
    color: #fff !important;
}
input.form-control-login-pass::placeholder {
  color: #fff; /* Soft grayish-beige */
  font-size: 14px;
  opacity: 0.8; /* Slight transparency */
}

/* For better browser compatibility */
input.form-control-login-pass::-webkit-input-placeholder {
  color: #fff !important;
}

input.form-control-login-pass::-moz-placeholder {
  color: #fff !important;
}

input.form-control-login-pass:-ms-input-placeholder {
  color: #fff !important;
}

input.form-control-login-pass:-moz-placeholder {
  color: #fff !important;
}
input.form-control-login::placeholder {
    color: #fff !important;
}
input.form-control-login::placeholder {
  color: #fff;
  font-size: 14px;
  opacity: 0.8;
}

/* For better browser compatibility */
input.form-control-login::-webkit-input-placeholder {
  color: #fff !important;
}

input.form-control-login::-moz-placeholder {
  color: #fff !important;
}

input.form-control-login:-ms-input-placeholder {
  color: #fff !important;
}

input.form-control-login:-moz-placeholder {
  color: #fff !important;
}
.cr-backimg {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    /* background: url('https://cdn.digicollect.com/cdn/digi_facelift/static/images/galaxy_new.png') no-repeat !important;
    background-size: cover !important;
    background-position: top !important;
    background-attachment: scroll !important; */
    /* padding-bottom: 600px; */
    background: url('https://cdn.digicollect.com/cdn/digi_facelift/static/images/nebula_ori.jpg') no-repeat center top/cover !important;
}
@media (max-width: 1280px) {
    .cr-backimg {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: url('https://cdn.digicollect.com/cdn/digi_facelift/static/images/nebula_ori.jpg') no-repeat center top/100% 115% !important;
    }
}
@media (max-width: 992px) {
    .cr-backimg {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: url('https://cdn.digicollect.com/cdn/digi_facelift/static/images/nebula_ori.jpg') no-repeat center top/cover !important;
    }
    .margin-t {
        margin-top: 30px;
    }
}
@media (max-width: 768px) {
    .cr-backimg {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: url('https://cdn.digicollect.com/cdn/digi_facelift/static/images/nebula_ori.jpg') no-repeat center top/cover !important;
    }
    .margin-t {
        margin-top: 30px;
    }
}
@media (max-width: 600px) {
    .cr-backimg {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: url('https://cdn.digicollect.com/cdn/digi_facelift/static/images/nebula_ori.jpg') no-repeat center top/cover !important;
    }
    .margin-t {
        margin-top: 30px;
    }
}
.img-social {
    width: 24px;
    height: 24px;
    line-height: 24px;
}
.img-social.facesoc {
    width: 28px;
    height: 28px;
    line-height: 28px;
}
.btn-white {
    border-radius: 6px !important;
    border: 2px solid #FFF !important;
    background: #FFF !important;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) !important;
    min-width: 5.2rem !important;
    height: 4.2rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 5px !important;
}
.followus-login {
    color: #FFF;
    text-align: center;
    font-size: 13px;
    font-weight: 600;
    line-height: normal;
    /* padding-bottom: 15px; */
    display: flex;
    align-content: center;
    justify-content: center;
    width: 100%;
    padding-left: 46.5px;
    padding-right: 46.5px;
}
.pb-15px {
    padding-bottom: 10px !important;
}
.img-email-login{
    width: 24px;
    height: auto;
    line-height: normal;
}
.pl-0-2, .px-0-2 {
    padding-left: .2rem !important;
}
.default-link {
    color: #fff;
    font-weight: 600;
    text-decoration: none !important;
    text-decoration-color: transparent !important;
    font-size: 13px !important;
    cursor: pointer;
}
input[type="password"]:-webkit-autofill {
    background-color: rgba(255, 255, 255, 0.5) !important; 
}

hr{
    border: 0;
    height: 1.4px;
    background-color: #ffff;
    width: 74px;
    margin: 10px auto;
}
</style>